import React, { FC } from "react"
import { StyleProp, ViewStyle } from "react-native"
import styled from "styled-components/native"

interface Props {
  style?: StyleProp<ViewStyle>
}

const BlurredBackground: FC<Props> = (props) => <StyledBlurView {...props} />

const StyledBlurView = styled.View`
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;

  backdrop-filter: blur(5px);
`;

export default BlurredBackground
